<template>
    <div v-if="props.uiMode === 'light'" :style="cssBinds[0][0]">
        <v-row dense>
            <v-col cols="12" :style="cssBinds[0][1]">
                {{ getLocationTitle() }}
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" :style="cssBinds[0][2]">
                {{ getLocationDetail() }}
            </v-col>
        </v-row>
    </div>
    <div v-else :style="cssBinds[1][0]">
        <v-row dense>
            <v-col cols="12" :style="cssBinds[1][1]">
                {{ getLocationTitle() }}
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" :style="cssBinds[1][2]">
                {{ getLocationDetail() }}
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
import { onMounted, onUpdated } from "vue";
import { faLog } from "../common/faCommon.js";

const FN = "[DeviceLocation] ";
const props = defineProps({
    uiMode: {
        type: String,
        required: true,
    },
    deviceLocation: {
        type: Object,
        required: true,
    },
});

onUpdated(() => {
    faLog(0, FN + "[onUpdated]");
});

onMounted(() => {
    faLog(0, FN + "[onMounted]");
});

const getLocationTitle = () => {
    if (props.deviceLocation.buildingName === undefined) { return ""; }
    if (props.deviceLocation.buildingName.length < 1) { return ( "[" + props.deviceLocation.detailAddress + "] " + props.deviceLocation.installedLocation); }
    return ("[" + props.deviceLocation.buildingName + "] " + props.deviceLocation.installedLocation);
};

const getLocationDetail = () => {
    if (props.deviceLocation.sido === undefined) { return ""; }
    if (props.deviceLocation.zipCode.length < 1) { return ( (props.deviceLocation.sido + props.deviceLocation.sigungu).trim() + " " + props.deviceLocation.roadAddress ); }
    return ( "[" + props.deviceLocation.zipCode + "] " + (props.deviceLocation.sido + props.deviceLocation.sigungu).trim() + " " + props.deviceLocation.roadAddress);
};

const cssBinds = [
    [
        {
            width: "calc(100% - 10px)",
            // height: "calc(100% - 10px)",
            overflowY: "auto",
            overflowX: "auto",
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "5px",
            marginBottom: "5px",
            borderColor: "#cccccc",
            borderRadius: "5px",
            borderStyle: "solid",
            // marginTop: "0px",
        },
        {
            textAlign: "left",
            color: "#01579b",
            fontSize: "1.1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "5px",
            marginBottom: "-5px",
        },
        {
            textAlign: "left",
            color: "black",
            fontSize: "1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "-5px",
            marginBottom: "5px",
        }
    ],
    [
        {
            width: "calc(100% - 10px)",
            // height: "calc(100% - 10px)",
            overflowY: "auto",
            overflowX: "auto",
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "5px",
            marginBottom: "5px",
            borderColor: "#505050",
            borderRadius: "5px",
            borderStyle: "solid",
            // marginTop: "0px",
        },
        {
            textAlign: "left",
            color: "#55c5f8",
            fontSize: "1.1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "5px",
            marginBottom: "-5px",
        },
        {
            textAlign: "left",
            color: "white",
            fontSize: "1rem",
            fontWeight: "normal",
            marginLeft: "10px",
            marginRight: "0px",
            marginTop: "-5px",
            marginBottom: "5px",
        }
    ],
];

</script>

